var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#F3FCEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2458 27.25H52.7458C53.5282 27.25 54.1624 27.8843 54.1624 28.6667V51.3333C54.1624 52.1158 53.5282 52.75 52.7458 52.75H27.2458C26.4634 52.75 25.8291 52.1158 25.8291 51.3333V28.6667C25.8291 27.8843 26.4634 27.25 27.2458 27.25ZM51.3291 33.2537L40.0975 43.3122L28.6624 33.2226V49.9167H51.3291V33.2537ZM29.387 30.0833L40.0835 39.5212L50.6222 30.0833H29.387Z",
    fill: "#7ED957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.9585d1e9f9013b7f39aad205567771e3.svg";
export { ForwardRef as ReactComponent };